var _circle, _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _path9, _path10, _ellipse, _ellipse2, _circle2, _ellipse3, _ellipse4, _circle3, _ellipse5, _path11, _rect2, _ellipse6, _path12, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSavannahJeep = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#FFE5B4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.1019 53.6565C77.1019 52.7116 76.3359 51.9456 75.391 51.9456H74.6586C73.7137 51.9456 72.9477 52.7116 72.9477 53.6565V53.8047C72.9477 54.7496 72.1817 55.5156 71.2368 55.5156H10.2685C9.32362 55.5156 8.55762 56.2816 8.55762 57.2265V58.8027C8.55762 59.7476 9.32363 60.5136 10.2685 60.5136H75.391C76.3359 60.5136 77.1019 59.7476 77.1019 58.8027V53.6565Z",
    fill: "#D5D8DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1019 52.2917C77.1019 52.1005 76.9469 51.9456 76.7557 51.9456C76.5645 51.9456 76.4095 52.1005 76.4095 52.2917V57.3747C76.4095 58.3196 75.6435 59.0856 74.6986 59.0856H9.27162C8.87729 59.0856 8.55762 59.4053 8.55762 59.7996C8.55762 60.1939 8.87729 60.5136 9.27162 60.5136H75.391C76.3359 60.5136 77.1019 59.7476 77.1019 58.8027V52.2917Z",
    fill: "#818A98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1875 19.1695H52.5011L58.6707 40.7631H56.3571L50.1875 19.1695Z",
    fill: "#7B9A68"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1367 23.7964H51.7303L55.5863 38.4493H30.1367V23.7964Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1367 23.7964H36.3063L40.1623 38.4493H30.1367V23.7964Z",
    fill: "#A4D0DA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.3984,
    y: 29.9668,
    width: 14.6528,
    height: 9.2544,
    rx: 1.71092,
    fill: "#C13925"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3984 31.6777C12.3984 30.7328 13.1644 29.9668 14.1094 29.9668H17.0256V39.2212H14.1094C13.1644 39.2212 12.3984 38.4552 12.3984 37.5103V31.6777Z",
    fill: "#892415"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6768 20.4912C31.6768 18.8425 29.5742 18.1477 28.5918 19.4718L15.965 36.4906C15.1273 37.6196 15.9332 39.2209 17.339 39.2209H19.6506C19.2912 38.671 19.244 37.9219 19.6791 37.3004L25.4789 29.015C26.4382 27.6446 28.5915 28.3233 28.5915 29.9961L28.5914 38.2815C28.5914 38.6285 28.4881 38.9513 28.3107 39.2209H29.9658C30.9107 39.2209 31.6767 38.4549 31.6767 37.51L31.6768 20.4912Z",
    fill: "#9DA4AF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3643 39.2207H30.1355C30.9872 39.2207 31.6779 38.5301 31.6779 37.6783V19.981C31.6779 18.7223 30.3185 18.0803 29.3643 18.6382V39.2207Z",
    fill: "#67717E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8945 42.9818C10.8945 40.6195 12.8095 38.7045 15.1718 38.7045H71.267C73.6292 38.7045 75.5443 40.6195 75.5443 42.9818V55.8405H10.8945V42.9818Z",
    fill: "#7B9A68"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8564 42.7263C10.8564 40.364 12.7715 38.449 15.1337 38.449H25.7897C27.4926 38.449 29.0332 39.4591 29.7122 41.0208L36.3061 56.1866H10.8564V42.7263Z",
    fill: "#516F3F"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.5235,
    cy: 58.6165,
    rx: 11.6837,
    ry: 11.6837,
    fill: "#3A3F46"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.5235,
    cy: 58.6164,
    rx: 5.84184,
    ry: 5.84184,
    fill: "#C4C4C4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.524,
    cy: 58.617,
    r: 4.38138,
    fill: "#9DA4AF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.9161,
    cy: 58.6165,
    rx: 11.6837,
    ry: 11.6837,
    fill: "#3A3F46"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.9161,
    cy: 58.6164,
    rx: 5.84184,
    ry: 5.84184,
    fill: "#C4C4C4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9165,
    cy: 58.617,
    r: 4.38138,
    fill: "#9DA4AF"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.1819,
    cy: 44.6187,
    rx: 1.928,
    ry: 4.6272,
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7963 44.6187C74.7963 47.1743 76.2467 49.2459 75.1819 49.2459C74.1171 49.2459 73.2539 47.1743 73.2539 44.6187C73.2539 42.0632 74.1171 39.9915 75.1819 39.9915C76.2467 39.9915 74.7963 42.0632 74.7963 44.6187Z",
    fill: "#5BABBD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 39.9915,
    width: 3.856,
    height: 14.6528,
    rx: 1.71092,
    fill: "#3A3F46"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5215,
    cy: 16.4704,
    rx: 2.6992,
    ry: 3.4704,
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7503 16.4704C29.7503 18.3871 32.0122 19.9408 30.5215 19.9408C29.0307 19.9408 27.8223 18.3871 27.8223 16.4704C27.8223 14.5538 29.0307 13 30.5215 13C32.0122 13 29.7503 14.5538 29.7503 16.4704Z",
    fill: "#5BABBD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.0762,
    y: 40.7632,
    width: 6.9408,
    height: 2.3136,
    rx: 1.1568,
    fill: "#505862"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSavannahJeep);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SavannahJeep.ddbaa9847551dc427c464f6e97b19280.svg";